import usePublicSettings from './usePublicSettings.js';
import { canonicalOrigin } from '../utils/canonicalUrl.js';

// Public settings plus the resolved canonical origin - the two things every
// structured-data builder needs to emit absolute, single-host URLs.
export default function useSiteContext() {
  const { settings } = usePublicSettings();
  return { settings, origin: canonicalOrigin(settings.siteCanonicalUrl) };
}
